import { useTranslation } from 'react-i18next';
import { Receipt } from 'lucide-react';

import { Alert, AlertDescription } from '@/components/ui/alert';

type Props = {
  isVisible: boolean;
};

export const FiscalReceiptNotice = (props: Props) => {
  const { isVisible } = props;
  const { t } = useTranslation();

  if (!isVisible) {
    return null;
  }

  return (
    <Alert>
      <Receipt className="size-4" />
      <AlertDescription>{t('Fiscal register hint')}</AlertDescription>
    </Alert>
  );
};
